import { parse } from 'querystring';

export function getParsedQueryStringFromUrl(url: string): any {
    if (url) {
        const queryStringStartIndex = url.indexOf('?');
        const queryString: string =
            queryStringStartIndex !== -1 ? url.slice(queryStringStartIndex + 1) : '';
        return parse(queryString);
    }

    return null;
}
